import { render, staticRenderFns } from "./ResultadoOperacional.vue?vue&type=template&id=06420b66&scoped=true&"
import script from "./ResultadoOperacional.vue?vue&type=script&lang=js&"
export * from "./ResultadoOperacional.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoOperacional.vue?vue&type=style&index=0&id=06420b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06420b66",
  null
  
)

export default component.exports